var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    fill: "none",
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF12",
    d: "m35.117 35.739 15.156 8.75-15.156 26.25c19.33 0 35-15.67 35-35 0-6.377-1.714-12.35-4.694-17.5H35.117v17.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M35.117.739C22.162.739 10.86 7.782 4.808 18.243L19.961 44.49l15.156-8.75v-17.5h30.306C59.37 7.78 48.07.739 35.117.739Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M.117 35.739c0 19.33 15.67 35 35 35l15.156-26.25-15.156-8.75-15.155 8.75L4.809 18.243A34.826 34.826 0 0 0 .117 35.739Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.617 35.739c0 9.665-7.835 17.5-17.5 17.5s-17.5-7.835-17.5-17.5 7.835-17.5 17.5-17.5 17.5 7.835 17.5 17.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M49.336 35.738c0 7.853-6.367 14.219-14.22 14.219-7.852 0-14.218-6.366-14.218-14.219s6.366-14.219 14.219-14.219c7.852 0 14.219 6.366 14.219 14.219Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 15.308,
    x2: 46.977,
    y1: 22.614,
    y2: 22.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53D30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 13.455,
    x2: 26.435,
    y1: 24.475,
    y2: 46.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279847"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.117.739h70v70h-70z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIcon);
export default __webpack_public_path__ + "static/media/chrome__icon.f351f905f3b400c7741de96c9ded2e83.svg";
export { ForwardRef as ReactComponent };